import { render, staticRenderFns } from "./SettlementForm.vue?vue&type=template&id=19907bb2&"
import script from "./SettlementForm.vue?vue&type=script&lang=ts&"
export * from "./SettlementForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports